export const DefaultLocalizationLabel = [

    { "RMMaster": "Manage Raw Material" },
    { "RMCategoryLabel": "RM Category" },
    { "BOPCategoryLabel": "BOP Category" },
    { "TechnologyLabel": "Technology" },
    { "VendorLabel": "Vendor" },
    { "RMVendorLabel": "Vendor" },
    { "BOPVendorLabel": "Vendor" },
]